module.exports = __webpack_public_path__ + "static/media/Cross-Negative.c2880455.svg";